/* eslint-disable */
import React from 'react'
import BreadCrumb from '../../components/breadcrumb'
import { Row, Col } from 'react-flexbox-grid'
import { KarirStyle } from './index.style'
import Section1 from '../../static/images/karir/section-1.svg'
import ShapeCircle from '../../static/images/karir/shape-circle.svg'
import ShapeDots from '../../static/images/karir/shape-dots-1.svg'
import Section3 from '../../static/images/karir/section-3.svg'
import Section4 from '../../static/images/karir/section-4.svg'
import Steve from '../../static/images/karir/steve-job.webp'
import Wilferd from '../../static/images/karir/wilfred-peterson.webp'
import Section61 from '../../static/images/karir/section-6-1.svg'
import Section62 from '../../static/images/karir/section-6-2.svg'
import Section63 from '../../static/images/karir/section-6-3.svg'
import { IoIosArrowForward } from "react-icons/io"
import Helmet from 'react-helmet'
import { useTranslation } from 'react-i18next'

const KarirPage = () => {
  const { t } = useTranslation();
  return (
    <KarirStyle>
      <Helmet>
        <title>Info Lowongan Pekerjaan | halojasa.com</title>
        <meta charSet="utf-8" />
        <meta name="description" content="Ingin bergabung dan berkontribusi menciptakan kebermanfaatan bersama kami ? Cek lowongan kerja yang ada" />
        <meta property="og:title" content="Tentang Visi dan Misi | halojasa.com" />
        <meta property="og:site_name" content="Halo Jasa" />
        <meta property="og:description" content="Cari tahu lebih dalam mengenai visi dan misi kami, lengkap dengan informasi profile perusahaan halojasa" />
        <meta property="og:url" content="https://halojasa.com/karir/all/" />
        <meta property="og:image" content="https://halojasa.com/blog/wp-content/uploads/2020/06/karir-ls.png" />
        <meta property="og:image:secure_url" content="https://halojasa.com/blog/wp-content/uploads/2020/06/karir-ls.png" />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image" itemProp="image" content="https://halojasa.com/blog/wp-content/uploads/2020/06/karis-sq.png" />
        <meta property="og:image:secure_url" itemProp="image" content="https://halojasa.com/blog/wp-content/uploads/2020/06/karis-sq.png" />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="300" />
        <meta property="og:image:height" content="300" />
        <meta property="og:type" content="website" />
        <meta property="fb:app_id" content="951866408583742" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@pthalojasa" />
        <meta name="twitter:title" content="Info Lowongan Pekerjaan | halojasa.com" />
        <meta name="twitter:description" content="Ingin bergabung dan berkontribusi menciptakan kebermanfaatan bersama kami ? Cek lowongan kerja yang ada" />
        <meta name="twitter:image:src" content="https://halojasa.com/blog/wp-content/uploads/2020/06/karir-ls.png" />
        <meta name="p:domain_verify" content="4e6fcb4deba1a02d84225fad69babc0b" />
        <meta name="keyword" content="lowongan kerja halo jasa" />
      </Helmet>
      <div className="karir-page-main-wrapper">
        <Row className="section-1">
          <Col lg={12} sm={12} md={12} xs={12}>
            <BreadCrumb
              options={[
                {
                  name: 'Beranda',
                  link: '/'
                },
                {
                  name: 'Tentang Kami',
                  link: '/bantuan/tentang-kami'
                },
                {
                  name: 'Karir',
                  link: false
                }
              ]}
            ></BreadCrumb>
          </Col>

          <div className="section-1-right mob-hide">
            <img src={Section1} alt="" />
          </div>

          <div className="section-1-left">
            <p className="section-1-title">{t('pageKarir.part1')}</p>
            <p className="section-1-desc">
              {t('pageKarir.part2')}
            </p>
            <p className="section-1-desc-2">
              {t('pageKarir.part3')}
            </p>
          </div>

          <div className="section-1-right mob-hide-force">
            <img src={Section1} alt="" />
          </div>
        </Row>

        <Row className="section-2">
          <img className="section-2-top-left" src={ShapeCircle} alt="" />
          <img className="section-2-bottom-right" src={ShapeDots} alt="" />

          <p className="section-2-text-1">
            {t('pageKarir.part4')}
          </p>

          <p className="section-2-text-2">
            {t('pageKarir.part5')}
          </p>

          <a href="/about/job-list/" className="smaller-hover">
            {t('pageKarir.part6')} <IoIosArrowForward style={{ position: 'relative', top: '3px' }} />
          </a>
        </Row>

        <Row className="section-3">
          <div className="section-3-left">
            <img src={Section3} alt="" />
          </div>

          <div className="section-3-right">
            <p className="section-3-title">{t('pageKarir.part7')}</p>

            <div className="section-3-bottom-line" />

            <p className="section-3-desc">
              {t('pageKarir.part8')}
            </p>
          </div>
        </Row>

        <Row className="section-4">
          <div className="section-4-left">
            <p className="section-4-title">{t('pageKarir.part9')}</p>

            <div className="section-4-bottom-line" />

            <div
              className="section-4-right mob-hide"
              style={{ marginBottom: '20px' }}
            >
              <img src={Section4} alt="" />
            </div>

            <p className="section-4-desc">
              {t('pageKarir.part10')}
              <br />
              {t('pageKarir.part11')}
            </p>
          </div>

          <div className="section-4-right mob-hide-force">
            <img src={Section4} alt="" />
          </div>
        </Row>

        <Row className="section-5">
          <div className="section-5-left">
            <p className="section-5-title">{t('pageKarir.part12')}</p>

            <p className="section-5-desc">
              {t('pageKarir.part13')}
              <br />
              {t('pageKarir.part14')}
            </p>
          </div>

          <div className="section-5-right">
            <div className="section-5-card">
              <div className="section-5-card-top">
                <img src={Steve} alt="" />
                Steve Jobs
              </div>

              <div className="section-5-card-bottom">
                <i>
                  "{t('pageKarir.part15')}"
                </i>
              </div>
            </div>

            <div className="section-5-card">
              <div className="section-5-card-top">
                <img src={Wilferd} alt="" />
                Wilferd Peterson
              </div>

              <div className="section-5-card-bottom">
                <i>
                  "{t('pageKarir.part16')}"
                </i>
              </div>
            </div>
          </div>
        </Row>

        <Row className="section-6">
          <p className="section-6-title">{t('pageKarir.part17')}</p>

          <p className="section-6-subtitle">
            {t('pageKarir.part18')}
          </p>

          <div className="section-6-card">
            <img src={Section61} alt="" />
            <p className="section-6-card-title">{t('pageKarir.part19')}</p>
            <p className="section-6-card-desc">
              {t('pageKarir.part20')}
            </p>
          </div>

          <div className="section-6-card">
            <img src={Section62} alt="" />
            <p className="section-6-card-title">{t('pageKarir.part21')}</p>
            <p className="section-6-card-desc">
              {t('pageKarir.part22')}
            </p>
          </div>

          <div className="section-6-card">
            <img src={Section63} alt="" />
            <p className="section-6-card-title">{t('pageKarir.part23')}</p>
            <p className="section-6-card-desc">
              {t('pageKarir.part24')}
            </p>
          </div>
        </Row>
      </div>
    </KarirStyle>
  )
}

export default KarirPage
